import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { NumberFormatter } from '@repo/toolkit/number'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getCenterCostsView } from '../../../../api/centers/get-center-costs-view'
import useTranslate from '../../../../lib/hooks/use-translate'
import { ActivityMemberEnum } from '../../../../lib/types/enums/activity-member/activity-member.enum'
import { CurrencyEnum } from '../../../../lib/types/enums/common/currency.enum'

type Props = {
  centerId: number
  currency?: CurrencyEnum
  mode?: 'open' | 'validate' | 'view' | 'staff-view'
}

const CenterLocalTransportFooter = ({ centerId, currency, mode }: Props) => {
  const { t } = useTranslate()
  const { data: costsView } = useQuery({
    queryKey: ['center-costs-view', centerId],
    queryFn: () => getCenterCostsView(centerId),
    enabled: !!centerId
  })

  const totalLocalTransportForFtrStudentsAndLeaders =
    costsView?.totalLocalTransportForFtrStudentsAndLeaders ?? 0
  const isPaidByLocalOrganizer =
    costsView?.localTransportAndAdminPaidBy === ActivityMemberEnum.ORGANIZER

  return (
    <div className="flex flex-col gap-2.5 mt-2.5">
      <div className="flex gap-2 mobile:flex-col">
        <Badge
          variant="purple"
          className="mobile:text-wrap mobile:w-2/5 mobile:h-fit mobile:py-1 "
          text={`${t('ol.center.local.transport.table.extra.transport.cost.for.ftr.students')} : ${costsView?.extraTransportCostForFtr ?? 0}`}
        />
        <Badge
          variant="purple"
          className="mobile:text-wrap mobile:w-2/5 mobile:h-fit mobile:py-1 "
          text={`${t('ol.center.local.transport.table.extra.transport.cost.for.leaders')} : ${costsView?.extraTransportCostForFrenchLeaders ?? 0}`}
        />
      </div>
      <div
        className={cn('w-full flex justify-between items-center pr-3 pb-2', {
          'justify-end mobile:justify-start mobile:pl-1 ': mode === 'staff-view'
        })}
      >
        {mode !== 'staff-view' && (
          <div className="flex items-center gap-1">
            <Typography variant="tag" color={tailwindColors.black.DEFAULT}>
              {t('ol.center.local.transport.table.total.local.transport.ftr.students.leaders')}
            </Typography>
            <Badge
              variant="purple"
              text={NumberFormatter.formatCurrency(
                totalLocalTransportForFtrStudentsAndLeaders,
                currency
              )}
            />
          </div>
        )}
        <div className="flex items-center gap-4">
          <Typography variant="label-semibold" color={tailwindColors.black.DEFAULT}>
            {isPaidByLocalOrganizer
              ? t('ol.center.local.transport.table.part.paid.by.local.organizer')
              : t('ol.center.local.transport.table.part.paid.by.french.leader')}
          </Typography>
          {mode !== 'staff-view' ? (
            <Typography variant="label-semibold" color={tailwindColors.black.DEFAULT}>
              {NumberFormatter.formatCurrency(
                totalLocalTransportForFtrStudentsAndLeaders,
                currency
              )}
            </Typography>
          ) : (
            <Badge
              variant="warning"
              text={NumberFormatter.formatCurrency(
                totalLocalTransportForFtrStudentsAndLeaders,
                currency
              )}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default CenterLocalTransportFooter
